import {FormikTextInput} from '@shipwell/shipwell-ui';
import {Field, Form, Formik} from 'formik';
import {DebouncedAutoSubmitter} from './debouncedAutoSubmitter/debouncedAutoSubmitter';
import {SearchFormValues} from './searchFormValues';

export interface SearchFormProps {
  onSearch: (values: SearchFormValues) => void;
}

export function SearchForm(props: SearchFormProps) {
  return (
    <Formik
      initialValues={{
        term: ''
      }}
      onSubmit={props.onSearch}
    >
      <Form>
        <Field name="term" label="Search for tags" component={FormikTextInput} />
        <DebouncedAutoSubmitter />
      </Form>
    </Formik>
  );
}
